import { supabase } from './supabase';

const ADMIN_PASSWORD = 'minedesmines231_coulommiers'; // À changer en production

export class AuthService {
  private static instance: AuthService;
  private isAuthenticated = false;

  private constructor() {
    // Vérifier si l'utilisateur est déjà authentifié
    const storedAuth = localStorage.getItem('admin_auth');
    if (storedAuth) {
      this.isAuthenticated = true;
    }
  }

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  public async login(password: string): Promise<boolean> {
    if (password === ADMIN_PASSWORD) {
      this.isAuthenticated = true;
      localStorage.setItem('admin_auth', 'true');
      return true;
    }
    return false;
  }

  public logout(): void {
    this.isAuthenticated = false;
    localStorage.removeItem('admin_auth');
  }

  public isLoggedIn(): boolean {
    return this.isAuthenticated;
  }
}

export const authService = AuthService.getInstance(); 